import axios from "axios";
import { useEffect, useRef, useState } from "react";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";
import { formInfo } from "./form-info";
import { FORMS_ROUTE } from "../../dashboard-routes";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE } from "../../../../routes";
import { useLocation } from "react-router";
import qs from "qs";
import PDFZipDownload from "../../common/pdf-zip-downloader";
import InlineFormToPDF from "./bucket-1/inline-form-pdf-template";
import Bucket2PDFTemplate from "./bucket-2/bucket-2-pdf-template";
import YesNoPDFGenerator from "./bucket-1/yes-no-form-generator";
import { schema as SG1Schema } from "./bucket-1/sg1-fair-trading-notification-form";
import { schema as SG9Schema } from "./bucket-1/sg9-gifts-and-benefits-register";
import { schema as SG7Schema } from "./bucket-1/sg7-complaint-form-register";
import { schema as SG10Schema } from "./bucket-1/sg10-review-of-operating-procedure";
import { schema as HalfYearlySchema } from "./bucket-1/half-yearly-form-schema";
import { sg3MonthlyChecklistLicenseeFormMap } from "./bucket-1/form-maps/sg3-monthly-checklist-licensee-form-map";
import { sg3YearlyChecklistLicenseeFormMap } from "./bucket-1/form-maps/sg3-yearly-checklist-licensee-form-map";

const SubmittedForms = () => {
    const [tableHeader, setTableHeader] = useState([
        { name: "", key: "isCompleted" },
        { name: "Form Id", key: "formIdDisplay" },
        { name: "Form Title", key: "formTitle" },
        { name: "Submitted By", key: "submittedBy" },
        { name: "Date", key: "submittedAt" },
    ]);
    const [tableData, setTableData] = useState([]);
    const [fetchComplete, setFetchComplete] = useState(false);
    const [taskLoading, setTaskLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [allForms, setAllForms] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const location = useLocation();

    function parseData(data) {
        let allFormData = [];
        //console.log(data);
        data.forEach((formState) => {
            let formInfoTemp = formInfo.find((f) => f.formType === formState.formType);

            if (formInfoTemp)
                allFormData.push({
                    formIdDisplay: (
                        <Link
                            to={{
                                pathname: DASHBOARD_ROUTE + FORMS_ROUTE + formInfoTemp.path,
                                state: {
                                    editForm: true,
                                    formState,
                                },
                            }}
                        >
                            {formState.formId}
                        </Link>
                    ),
                    formId: formState.formId,
                    formTitle: formState.formTitle,
                    submittedBy: formState?.lastEditedByUserDetails?.fullName,
                    submittedAt: new Date(formState.lastEditedTimeStamp).toDateString(),
                });
        });

        return allFormData;
    }

    useEffect(() => {
        var config = {
            method: "get",
            url: dataProvider.baseUrl + "forms-getFormsByOrgId",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
        };

        axios(config)
            .then(function (response) {
                // console.log("Forms", response.data);
                setAllForms(response.data);
                setFetchComplete(true);
                let data = parseData(response.data);
                setTableData(data);

                if (location.state?.successMsg) {
                    setSuccessMsg(location.state.successMsg);
                }
            })
            .catch((error) => {
                setFetchComplete(true);
                console.error(error);
            });
    }, []);

    const temp = useRef();
    async function downloadForms() {
        // get all form templates into a object
        let pdf = [];
        let names = [];

        const formIdList = selectedRows.map(row => row.formId) ;
        const formsToDownload = allForms.filter(form => formIdList.includes(form.formId)) ;

        setIsDownloading(true);
        for (let form of formsToDownload) {
            // console.log(form.formType)
            if (form.formType === "SG1FairTradingNotificationForm") {
                let res = await InlineFormToPDF(SG1Schema, form.formType, form.formTitle);
                pdf.push(res);
                names.push(form.formTitle || form.formType);
            } else if (form.formType === "SG9GiftsAndBenefitsRegister") {
                let res = await InlineFormToPDF(SG9Schema, form.formType, form.formTitle);
                pdf.push(res);
                names.push(form.formTitle || form.formType);
            } else if (form.formType === "SG7ComplaintFormRegister") {
                let res = await InlineFormToPDF(SG7Schema, form.formType, form.formTitle);
                pdf.push(res);
                names.push(form.formTitle || form.formType);
            } else if (form.formType === "SG10ReviewOfOperatingProcedure") {
                let res = await InlineFormToPDF(SG10Schema, form.formType, form.formTitle);
                pdf.push(res);
                names.push(form.formTitle || form.formType);
            } else if (form.formType === "SG2PolicyAndProcedureForm") {
                let res = await Bucket2PDFTemplate(form);
                pdf.push(res);
                names.push(`${form.formTitle || form.formType} - ${form.formId}`);
            } else if (form.formType === "SG3DailyBankingChecklist") {
                let res = await Bucket2PDFTemplate(form);
                pdf.push(res);
                names.push(`${form.formTitle || form.formType} - ${form.formId}`);
            } else if (form.formType === "SG3MonthlyChecklistForm") {
                let res = await Bucket2PDFTemplate(form);
                pdf.push(res);
                names.push(`${form.formTitle || form.formType} - ${form.formId}`);
            } else if (form.formType === "SG3MonthlyChecklistLicenseeForm") {
                let res = YesNoPDFGenerator(sg3MonthlyChecklistLicenseeFormMap, form, [
                    {
                        position: "top",
                        field: "Monthly checklist Licensee – For the Month of ",
                        value: monthNames[form.month || 0],
                    },
                ]);
                pdf.push(res);
                names.push(`${form.formTitle || form.formType} - ${form.formId}`);
            } else if (form.formType === "SG3YearlyChecklistLicenseeForm") {
                let res = YesNoPDFGenerator(sg3YearlyChecklistLicenseeFormMap, form, [
                    {
                        position: "bottom",
                        field: "Name of Auditor",
                        value: form.auditorName || "",
                    },
                ]);
                pdf.push(res);
                names.push(`${form.formTitle || form.formType} - ${form.formId}`);
            } else if (form.formType === "HalfYearlyFilesReviewForm") {
                let res = YesNoPDFGenerator(HalfYearlySchema, form, [
                    {
                        position: "bottom",
                        field: "",
                        value:
                            `I, <u>${form.acknowledgementName}</u> ,acknowledge that I have carried out the above monthly review and confirm that my responses are true
                    and correct.` || "-",
                    },
                ]);
                pdf.push(res);
                names.push(`${form.formTitle || form.formType} - ${form.formId}`);
            }
        }

        if(pdf.length > 0) {
            PDFZipDownload(pdf, names).then(() => {
                setIsDownloading(false);
            });
        } else {
        setIsDownloading(false);
        }
    }

    return (
        <div id="tasks">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Submitted Forms</div>
                    <div className="flex-fill"></div>
                    {isDownloading ? (
                        <button
                            type="submit"
                            form="addMemberForm"
                            className="btn btn-primary text-white d-flex align-items-center"
                            disabled={true}
                        >
                            Downloading
                            <div className="spinner-border spinner-border-sm ms-3" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                    ) : (
                        <button
                            onClick={downloadForms}
                            type="submit"
                            form="addMemberForm"
                            className="btn btn-primary text-white"
                            disabled={selectedRows.length === 0}
                        >
                            Download Forms as a ZIP file
                        </button>
                    )}
                </div>
            </div>

            {successMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            <div className="container-fluid p-3">
                <div className="card p-3 border-0">
                    {fetchComplete ? (
                        <div className="position-relative">
                            <DataTable 
                                header={tableHeader} 
                                rawData={tableData} 
                                selectable
                                setSelectedRows={setSelectedRows}
                                paginate
                            />

                            {taskLoading && (
                                <div
                                    className="position-absolute top-0 left-0 w-100 h-100 bg-dark"
                                    style={{ zIndex: "99", opacity: "0.1", cursor: "wait" }}
                                ></div>
                            )}
                        </div>
                    ) : (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Forms</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* <div className="container-fluid p-3 mb-5 ">
                <div className="card p-3 border-0">
                    <div ref={temp}></div>
                </div>
            </div> */}
        </div>
    );
};

export default SubmittedForms;

const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
